var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "online-course-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.942,
    height: 21,
    viewBox: "0 0 38.942 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_65344",
    "data-name": "Path 65344",
    d: "M.865,19.273H4.2a.744.744,0,0,1-.555-.716V.738A.741.741,0,0,1,4.379,0h29.99a.741.741,0,0,1,.738.738V18.554a.741.741,0,0,1-.555.716h3.524a.866.866,0,0,1,.865.865h0a.866.866,0,0,1-.865.865H.865A.866.866,0,0,1,0,20.135H0a.864.864,0,0,1,.865-.862Zm8.613-15.8H17.2v9.266c-.016.26-.349.266-.71.25H9.354a.909.909,0,1,0,0,1.819h7.469v-.966h.71v1.23a.406.406,0,0,1-.406.406H9.389a1.241,1.241,0,0,1-1.635-1.3V5.2A1.732,1.732,0,0,1,9.478,3.476ZM21.146,14.986a.5.5,0,0,1,0-1h9.282a.5.5,0,0,1,0,1ZM21.079,4.05H31.305a.4.4,0,0,1,.4.4V5.875a.4.4,0,0,1-.4.4H21.079a.4.4,0,0,1-.4-.4V4.449a.4.4,0,0,1,.4-.4Zm.067,5.34a.5.5,0,0,1,0-1H29.79a.5.5,0,0,1,0,1Zm0,2.8a.5.5,0,0,1,0-1h7.3a.5.5,0,0,1,0,1ZM9.8,4.823h.288a.247.247,0,0,1,.266.215V11.81a.247.247,0,0,1-.266.215H9.8a.247.247,0,0,1-.266-.215V5.038A.245.245,0,0,1,9.8,4.823ZM4.9,1.157H33.945V18.344H4.9V1.157ZM18.744,19.6h2.431a.417.417,0,0,1,.415.415h0a.417.417,0,0,1-.415.415H18.744a.417.417,0,0,1-.415-.415h0a.415.415,0,0,1,.415-.415Z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourses);
export default __webpack_public_path__ + "static/media/Courses.c85d7340eba85259dcdc3dc3a8e4b976.svg";
export { ForwardRef as ReactComponent };